interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white shadow-md backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8ee4107a0391ff41e9853657d04e9e24/11ab73c7ebd49d098a25df4db0ff452f.jpeg" 
              alt="AMD Gestion Immobilière" 
              className="h-12 w-auto object-contain"
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('services')}
              className={`text-xs uppercase tracking-wider font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1A3B5C]' : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('methode')}
              className={`text-xs uppercase tracking-wider font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1A3B5C]' : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Méthode
            </button>
            <button
              onClick={() => scrollToSection('zones')}
              className={`text-xs uppercase tracking-wider font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1A3B5C]' : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Zones
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-xs uppercase tracking-wider font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#1A3B5C]' : 'text-white hover:text-[#C9A961]'
              }`}
            >
              Contact
            </button>
          </div>

          <a
            href="https://wa.me/221XXXXXXXXX"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#1A3B5C] text-white px-6 py-2 rounded-lg hover:bg-[#2A4B6C] transition-all duration-300 flex items-center space-x-2 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            <span className="text-sm font-medium">WhatsApp</span>
          </a>
        </div>
      </div>
    </nav>
  );
}
